export default {
  doc: {
    list: {
      statusIssued: "Issued",
      statusUploaded: "Uploaded",
      publish: "Publish",
      unpublish: "Unpublish",
      viewPdf: "View PDF",
      replacePdf: "Replace PDF",
      viewDeclaration: "View declaration",
      downloadPdf: "Download PDF",
      editDeclaration: "Edit declaration",
      continueEditing: "Continue editing",
      declarationNumber: "Declaration number",
      continueHint: "Continue editing to complete this declaration",
      loading: "Loading declarations",
      loadFailed: "Could not load declarations.",
      tryAgain: "Try again",
    },
    composition: {
      issuedLocked: "Issued declarations cannot be changed.",
      noPackagingData: "Packaging data is not available, so components cannot be added.",
      setEndUser: "Set the intended end user (Household or Industrial) on the Packaging SKU before adding components.",
      nonEditableHint: "Components saved without editable Packaging SKU data can be removed but not edited. To change one, remove it and add the element again.",
      loading: "Loading packaging components…",
      empty: "No packaging components",
      emptyDescription: "Components are managed in the Packaging record.",
      issues: {
        multipleMain: "Only one Main element is allowed.",
        invalidWeight: "Element {{number}}: Enter the component weight.",
        invalidMaterialWeight: "Element {{number}}: Each added material needs a material and a weight.",
        weightMismatch: "Element {{number}}: Component and material weights do not add up.",
        generic: "Element {{number}}: {{code}}",
        unsupportedRole: "Component {{number}} has the role \"{{role}}\", which the server does not accept. Remove it and add it again before changing the composition.",
        incomplete: "Element {{number}}: choose its material and weight in the drawer, or remove it.",
        unsupportedRoleSave: "Component {{index}} (\"{{type}}\") has the role \"{{role}}\", which the server does not accept. The composition was not saved. Remove this component and add it again, or contact support. Your other changes are kept.",
      },
      lockedTitle: "Packaging composition editing is temporarily unavailable",
      lockedBody: "We're updating this feature. You can still review existing components and continue completing your declaration.",
      importPending: "Imported components will be saved when you continue.",
      structure: {
        oneMaterial: "One material",
        composite: "Composite",
        multiLayer: "Multi-layer",
      },
      role: {
        main: "Main",
        additional: "Additional",
      },
      type: {
        primary: "Primary (product packaging)",
        shipping: "Shipping (transport packaging)",
      },
      packagingId: "Packaging ID",
      intendedEndUser: "Intended end user",
    },
    common: {
      searchCountry: "Search country",
      noResults: "No results found",
      loading: "Loading…",
      country: "Country",
      continue: "Continue",
      title: "Title",
      description: "Description",
      add: "Add",
      component: "Component",
      material: "Material",
      weight: "Weight",
      packagingComponent: "Packaging component",
      unit: "Unit",
      notes: "Notes",
      companyName: "Company name",
      streetAddress: "Street address",
      postalCode: "Postal code",
      city: "City",
      email: "Email",
      saveChanges: "Save changes",
      phone: "Phone",
      requestFailed: "Request failed",
      fullName: "Full name",
      selectDate: "Select date",
      remove: "Remove",
      replace: "Replace",
      upload: "Upload",
      keepEditing: "Keep editing",
      reload: "Reload",
      reference: "Reference",
      invalidResponse: "Invalid response from server",
      required: "Required",
      optional: "(optional)",
      notApplicable: "Not applicable",
      address: "Address",
    },
    confirm: {
      publishOverTitle: "Replace the published declaration?",
      replacePublishedTitle: "Replace published PDF?",
      replacePublishedBody: "This PDF is published. The new file will be shown on the public label.",
      deleteTitle: "Delete declaration?",
      deletePublishedBody: "This declaration is published. It will no longer appear on the public label.",
      deleteBody: "This declaration will be permanently removed.",
      publishOverBody: "{{name}} will stop showing on the public label.",
    },
    entry: {
      lappaBullets: {
        noDeclaration: "No declaration yet",
        keepInSync: "Want it kept in sync with your packaging data",
        signOnline: "Sign online or send for signature",
      },
      uploadBullets: {
        issuedByYou: "Issued by you or a consultant",
        pdfOnly: "PDF only, max 20 MB",
        managedHere: "Managed here in Document of conformity",
      },
      title: "Add a Declaration of Conformity",
      subtitle: "Create a new declaration with Lappa, or attach one you already have.",
      createWithLappa: "Create with Lappa",
      recommended: "Recommended",
      createDescription: "A structured wizard pre-filled from this packaging. Lappa generates the PDF for you to sign.",
      uploadExisting: "Upload existing PDF",
      uploadDescription: "You already have a signed declaration. Attach it as a ready PDF (max 20 MB).",
      uploadPdf: "Upload PDF",
      footnote: "You can add another declaration later from this tab.",
    },
    legislation: {
      alreadyListed: "This legislation is already listed.",
      searchPlaceholder: "Search by regulation number or title...",
      unionLegislation: "Union legislation",
      alreadyAdded: "Already added to this declaration.",
      editCustomAria: "Edit custom legislation",
      otherTitle: "Other (enter manually)",
      otherDescription: "Add a different Union act not listed above.",
      addLegislation: "Add legislation",
      addUnionTitle: "Add Union legislation",
      addUnionDescription: "Select a Union act that applies to this packaging.",
      addCustomTitle: "Add custom legislation",
      addCustomDescription: "Enter the details of the Union act.",
      titlePlaceholder: "e.g. Regulation (EU) 2022/…",
      descriptionPlaceholder: "Optional description",
      titleRequired: "Title is required.",
      baseTitle: "Base legislation (required by PPWR)",
      statementTitle: "Declaration statement (required by PPWR)",
      otherHint: "Add other Union acts that apply to this packaging, for example for food contact materials.",
      removeAria: "Remove legislation",
      otherApplicable: "Other applicable Union legislation",
      unionActCode: "Union act {{code}}",
      unionAct: "Union act",
    },
    newMenu: {
      createDescription: "Step-by-step wizard. Lappa pre-fills packaging data and generates a PDF you can sign.",
      newDeclaration: "New declaration",
    },
    componentEditor: {
      invalidWeight: "Enter a valid component weight.",
      detailRequired: "Enter at least one component detail.",
      selectComponent: "Select component",
      role: "Role",
      roleHelper: "The component's role in the packaging, e.g. closure.",
      selectMaterial: "Select material",
      componentWeight: "Component weight",
      category: "Category",
      selectCategory: "Select category",
      addComponent: "Add component",
      editComponent: "Edit component",
    },
    componentModal: {
      componentType: "Component type (value)",
      materialFamily: "Material family (value)",
    },
    party: {
      roles: {
        manufacturer: "Manufacturer",
        importer: "Importer",
        authorisedRepresentative: "Authorised representative",
      },
      countryCode: "Country code",
      addParty: "Add party",
      representativeType: "Representative type",
      representativeTypeHint: "Choose who acts as the authorised representative in the EU.",
      representativeTypeAria: "Authorised representative type",
      lappaSelectedHint: "Lappa is selected as the authorised representative. No company details are entered here.",
      anotherRepresentative: "Another authorised representative",
      addTitle: {
        manufacturer: "Add manufacturer",
        importer: "Add importer",
        authorisedRepresentative: "Add authorised representative",
        party: "Add party",
      },
      editTitle: {
        manufacturer: "Edit manufacturer",
        importer: "Edit importer",
        authorisedRepresentative: "Edit authorised representative",
        party: "Edit party",
      },
      fields: {
        companyName: "Company Name",
        streetAddress: "Street Address",
        postalCode: "Postal Code",
      },
    },
    pdf: {
      loading: "Loading declaration PDF…",
      loadFailed: "The declaration PDF could not be loaded.",
      controls: "PDF view controls",
      previousPage: "Previous page",
      nextPage: "Next page",
      zoomOut: "Zoom out",
      zoomIn: "Zoom in",
      fitWidth: "Fit width",
      page: "Page {{pageNumber}}",
      canStillDownload: "{{error}} You can still download it.",
      documentAria: "Declaration PDF {{fileName}}",
      empty: "The declaration PDF is empty.",
      readFailed: "Could not read PDF",
      displayFailed: "The PDF could not be displayed in the preview.",
      notAvailable: "PPWR declaration PDF is not available",
      invalidLink: "The PDF link returned by the server is not valid.",
    },
    send: {
      invalidationInfo: "The signer receives a signing link by email. Sending a new invitation invalidates any link sent earlier for this declaration.",
      unsavedWarning: "You have unsaved changes on earlier steps. The signer receives the last saved version.",
      serverDecides: "The server decides whether the declaration is ready to send for signature.",
      signerEmail: "Signer email",
      expiresOn: "Link expires on",
      message: "Message",
      messagePlaceholder: "Optional message for the signer",
      send: "Send",
      title: "Send for signature",
      description: "Email a signing invitation to an external signer.",
      expiresHint: "Optional. The link stays valid until 23:59 on this date ({{timeZone}}). Leave empty for the default of 14 days.",
      errors: {
        signerEmail: "Enter the signer email.",
        invalidEmail: "Enter a valid email address.",
        invalidDate: "Select a valid date.",
        pastDate: "Select today or a later date.",
      },
    },
    sign: {
      signerName: "Signer name",
      title: "Sign declaration",
      description: "Complete the required signature details to finalize the declaration.",
      errors: {
        signedFor: "Enter who the declaration is signed for.",
        place: "Enter the signature place.",
        date: "Select the signature date.",
        signerName: "Enter the signer name.",
        signerFunction: "Enter the signer function.",
        selectImage: "Select a PNG or JPG signature image.",
        typeSignature: "Type your signature.",
        signFailed: "Could not sign the declaration.",
        readFile: "Could not read file",
        unsupportedImage: "Only PNG or JPG images are supported.",
        emptyImage: "The selected image is empty.",
        imageTooLarge: "The signature image must be 5 MB or smaller.",
        imageUnreadable: "The selected image could not be read.",
        invalidImage: "The selected file is not a valid PNG or JPG image.",
        typedUnsupported: "Typed signatures are not supported in this browser.",
        createFailed: "Could not create the signature image.",
      },
      signedFor: "Signed for and on behalf of",
      place: "Signature place",
      placePlaceholder: "City, country",
      date: "Signature date",
      signerFunction: "Signer function",
      method: "Signature method",
      uploadImage: "Upload image",
      uploadImageDescription: "Use an existing signature image",
      type: "Type",
      typeDescription: "Type your name and choose a style",
      image: "Signature image",
      imageHint: "PNG or JPG, up to 5 MB. A transparent or white background works best.",
      preview: "Signature preview",
      replaceImage: "Replace image",
      chooseImage: "Choose image",
      typeLabel: "Type your signature",
      typeHint: "Enter your full name as you would like it to appear in the signature.",
      chooseStyle: "Choose style",
      yourSignature: "Your signature",
      previewHint: "When you apply the signature, this preview is converted into a PNG image and added to the declaration.",
      notQualified: "The signature is placed on the declaration as an image. It is not a qualified electronic signature.",
      apply: "Apply signature",
      styles: {
        classic: "Classic",
        elegant: "Elegant",
        modern: "Modern",
        formal: "Formal",
      },
    },
    upload: {
      pdfRequired: "Upload a PDF file.",
      maxSize: "Maximum file size is 20 MB.",
      replaceTitle: "Replace declaration PDF",
      uploadTitle: "Upload declaration PDF",
      onlyOne: "You can upload only one PDF at a time.",
      replaceDescription: "Choose a new signed Declaration of Conformity PDF.",
      uploadDescription: "Upload a signed Declaration of Conformity you already have.",
      selectFile: "Select PDF file",
      helper: "PDF only • Maximum file size 20 MB • One file at a time",
      uploadFailed: "Upload failed",
      replaceFailed: "Replace failed",
    },
    wizardModals: {
      autofill: {
        title: "Auto-fill declaration",
        description: "Empty fields will be filled using available packaging and label information. Your existing entries will be preserved.",
        confirm: "Auto-fill",
      },
      destructiveStep: {
        title: "Reset signature and PDF?",
        description: "Saving these changes returns the declaration to Draft and removes its signature and issued PDF. If you cancel, the issued declaration stays unchanged and your edits are kept on this screen.",
        confirm: "Save and reset",
      },
      destructiveDraftPdf: {
        title: "Save changes to this draft?",
        description: "The generated PDF will no longer match the declaration. After saving, generate a new PDF before signing. If you cancel, nothing is saved and your edits are kept on this screen.",
      },
      destructivePdf: {
        title: "Replace existing PDF?",
        description: "Generating a new unsigned PDF will reset the declaration to draft and remove the current signature and PDF.",
        confirm: "Generate unsigned PDF",
      },
      leave: {
        title: "Leave this declaration?",
        description: "You have unsaved changes. Returning to all declarations will discard changes that have not been saved with Next.",
        confirm: "Leave",
      },
      deleteLogo: {
        title: "Remove brand logo?",
        description: "The logo will be removed from this declaration. You can upload a new logo at any time.",
        confirm: "Remove logo",
      },
      conflict: {
        description: "Someone else saved manufacturer, importer or representative details for this packaging. Your version is out of date, so your last save was not applied. Reload replaces the Parties step with the latest saved values and keeps unsaved edits in other steps.",
        confirm: "Reload parties",
      },
    },
    shared: {
      conflictTitle: "Shared party data changed",
      changeTitle: "Save shared party changes?",
      changeBody: "These manufacturer, importer and representative details are shared with this packaging's Digital Label and other Declarations of Conformity.",
      conflictBody: "Someone else saved manufacturer, importer, representative or target market details for this packaging. Your version is out of date, so your last save was not applied.",
      reloadTitle: "Reload from server?",
      reloadBody: "Unsaved changes to shared parties or target market on this label will be discarded. The form will show the latest values from the server.",
      editNotice: "Changes to these details will also apply to this packaging's Digital Label and Declarations of Conformity.",
      removeNotice: "Disabling this party will also remove it from the Digital Label and all Declarations of Conformity for this packaging.",
      documents: {
        thisLabel: "this label",
        digitalLabel: "Digital Label",
        thisDeclarationNumber: "this declaration ({{number}})",
        thisDeclaration: "this declaration",
        declarationNumber: "Declaration {{number}}",
        declarationOfConformity: "Declaration of Conformity",
        document: "Document",
      },
      impact: {
        labelRegenerated: "{{document}}: its PDF is regenerated; QR code and link stay the same.",
        issued: "{{document}}: stays issued and signed; its PDF is regenerated.",
        draftReset: "{{document}}: its PDF is reset; generate a new one before signing.",
        openSigning: "{{document}}: has an open signing request.",
        publishedLabel: "The published Digital Label PDF is regenerated; QR code and link stay the same.",
        issuedDeclarations: "Issued declarations stay issued and signed; their PDFs are regenerated.",
        openSigningRequests: "A declaration has an open signing request.",
        draftWithPdf: "Draft declarations with a PDF have their PDF reset; generate a new one before signing.",
      },
      warnings: {
        declarationPdfFailed: "Your changes were saved, but the declaration PDF could not be regenerated. The previous PDF is still shown.",
        labelPdfFailed: "The Digital Label PDF could not be regenerated. Open the Digital Label and generate it again.",
        labelPdfFailedSaved: "Your changes were saved, but the Digital Label PDF could not be regenerated.",
        declarationNumberPdfFailed: "Declaration {{number}}: PDF could not be regenerated.",
        declarationPdfFailedGeneric: "A declaration PDF could not be regenerated.",
      },
    },
    substance: {
      declaredValue: "Declared value",
      whatWasChecked: "What was checked?",
      selectCheckType: "Select check type",
      loadingCheckTypes: "Loading check types…",
      catalogError: "Could not load substance check options.",
      assessment: "Assessment",
      assessmentPlaceholder: "Describe the assessment",
      substanceName: "Substance name",
      characteristics: "Characteristics",
      legalReference: "Legal reference",
      legalLink: "Legal link",
      legalLimitOperator: "Legal limit operator",
      selectOperator: "Select operator",
      legalLimitValue: "Legal limit value",
      limitValue: "Limit value",
      legalLimitUnit: "Legal limit unit",
      legalLimitText: "Legal limit (text)",
      legalLimitTextPlaceholder: "Text-only limit when no numeric value is used",
      value: "Value",
      legalLimit: "Legal limit",
      selectUnit: "Select unit",
      declaredUnit: "Declared unit",
      foodContact: "Food contact",
      selectOption: "Select option",
      conformityStatus: "Conformity status",
      selectStatus: "Select status",
      evidence: "Evidence",
      selectEvidence: "Select evidence",
      assessmentDetails: "Assessment details",
      assessmentDetailsPlaceholder: "Required when above the legal limit and status is Complies",
      notApplicableReason: "Not applicable reason",
      notApplicableReasonPlaceholder: "Required when status is Not applicable",
      addRecord: "Add record",
      editTitle: "Edit substance record",
      addTitle: "Add substance record",
      checkType: "Check type",
      reason: "Reason",
      entirePackaging: "Entire packaging",
      errors: {
        componentNotFound: "Packaging component was not found. Reselect the packaging component.",
        componentChanged: "Packaging component changed. Reselect the packaging component.",
        checkTypeRequired: "Check type is required.",
        statusRequired: "Conformity status is required.",
        evidenceTypeRequired: "Evidence type is required.",
        evidenceRequired: "Evidence is required when status is Complies.",
        foodContactRequired: "Food contact is required for PFAS.",
        compliesNotAllowed: "Complies is not allowed when food contact is Unknown.",
        substanceNameRequired: "Substance name is required.",
        characteristicsRequired: "Characteristics are required.",
        invalidNumber: "Enter a valid number.",
        negative: "Value must be zero or greater.",
        operatorRequired: "Select a legal limit operator.",
        unitTooLong: "Unit must be 20 characters or fewer.",
        assessmentRequired: "Assessment text is required.",
        assessmentDetailsRequired: "Assessment details are required when above the legal limit.",
        reasonRequired: "Reason is required when status is Not applicable.",
        selectComponent: "Select a packaging component.",
        reselectComponent: "Reselect the packaging component.",
      },
      notProvided: "Not provided",
      noNumericLimit: "No numeric limit",
      catalogEmpty: "No substance check types are available.",
      sectionTitle: "Substances of concern (optional)",
      sectionHint: "Add substance checks when relevant.",
      saveFirstHint: "Save this step to add substance records.",
      resourceSingular: "substance record",
      resourcePlural: "substance records",
      emptyDescription: "Substance records are optional.",
      empty: "No substance records yet",
      deleteTitle: "Delete substance record?",
      deleteBody: "This substance record will be removed from the declaration. Save the step with Next to persist the change.",
      deleteRecord: "Delete record",
      rowWarning: "Substance record {{label}}: {{warning}}",
      rowError: "Substance record {{label}}: {{errors}}",
      rowErrorEdit: "Substance record {{label}}: {{errors}} Edit the row to complete it.",
    },
    tests: {
      testNumber: "Test number",
      testNumberPlaceholder: "Enter test number",
      testDate: "Test date",
      referenceType: "Reference type",
      selectType: "Select type",
      referencePlaceholder: "Reference identifier",
      addTestReference: "Add test reference",
      editTestReference: "Edit test reference",
      types: {
        standard: "Standard",
        commonSpecification: "Common specification",
        otherTechnicalSpecification: "Other technical specification",
      },
      sectionTitle: "Test references (optional)",
      sectionHint: "Add only if you have test information.",
      resourceSingular: "test reference",
      resourcePlural: "test references",
      emptyDescription: "Test references are optional.",
      empty: "No test references yet",
      rowError: "Test reference {{name}}: {{errors}} Edit the row to complete it.",
    },
    steps: {
      identification: {
        label: "Declaration details & identification",
        sidebarDescription: "Basic declaration information.",
        description: "Provide the basic information for this declaration.",
      },
      parties: {
        label: "Manufacturer & other parties",
        sidebarDescription: "Manufacturer / brand owner, importer and representative.",
        description: "Provide the manufacturer / brand owner details and, where applicable, add an importer or authorised representative.",
      },
      componentsTests: {
        label: "Packaging components, tests & substances",
        sidebarDescription: "Packaging components, test references and substance checks.",
        description: "Review the packaging components from the package data. Test references and substances of concern checks are optional.",
      },
      legislation: {
        label: "Applicable legislation",
        sidebarDescription: "Confirm applicable Union legislation.",
        description: "Confirm the Union legislation applicable to this declaration.",
      },
      notifiedBody: {
        label: "Notified body",
        sidebarDescription: "Whether a notified body was involved.",
        description: "Indicate whether a notified body was involved in the conformity assessment for this packaging.",
      },
      issuance: {
        label: "Additional information",
        sidebarDescription: "Optional details and importer information.",
        description: "Add any additional information (optional) and, if applicable, provide importer details.",
      },
      reviewSign: {
        label: "Review & sign",
        panelTitle: "Declaration preview",
        sidebarDescription: "Review the PDF and sign.",
        description: "Please review the declaration before signing.",
      },
    },
    logo: {
      invalidType: "Brand logo must be PNG or JPG.",
      maxSize: "Maximum file size is 5 MB.",
      notRestored: "Logo file was not restored from a saved draft. Select the logo again if needed.",
      title: "Brand logo",
      helper: "PNG or JPG. Max size 5 MB.",
      uploading: "Uploading…",
      replace: "Replace logo",
    },
    wizard: {
      allDeclarations: "All declarations",
      loadFailed: "Could not load this declaration.",
      saveDraftDirty: "You have unsaved changes. Save them with Next on the changed step before saving the draft.",
      saveDraft: "Save Draft",
      saveRecordFirst: "Save the packaging record before creating a declaration of conformity.",
    },
    fields: {
      packagingName: "Packaging name",
      manufacturerCompanyName: "Manufacturer company name",
      manufacturerAddress: "Manufacturer address",
      manufacturerPostalCode: "Manufacturer postal code",
      manufacturerCity: "Manufacturer city",
      manufacturerCountry: "Manufacturer country",
      notifiedBodyName: "Notified body name",
      notifiedBodyAddress: "Notified body address",
      identificationNumber: "Notified body identification number",
      descriptionOfIntervention: "Notified body intervention",
      certificateNumber: "Notified body certificate reference",
      certificateDate: "Notified body certificate date",
      testReferenceType: "Test reference {{number}} type",
      testReferenceValue: "Test reference {{number}} reference",
    },
    validation: {
      companyNameRequired: "Company name is required.",
      addressRequired: "Address is required.",
      cityRequired: "City is required.",
      countryInvalid: "Select a valid country.",
      referenceTypeRequired: "Reference type is required.",
      referenceRequired: "Reference is required.",
      declarationNumberRequired: "Declaration number is required.",
      packagingNameRequired: "Packaging name is required.",
      postalCodeRequired: "Postal code is required.",
      invalidState: "Invalid form state.",
      finishElement: "Finish this element in the drawer or remove it.",
      legislationRequired: "At least one legislation entry is required.",
      notifiedBodyNameRequired: "Notified body name is required.",
      identificationNumberRequired: "Identification number is required.",
      interventionRequired: "Description of intervention is required.",
      certificateNumberRequired: "Certificate reference / number is required.",
      certificateDateRequired: "Certificate date is required.",
      maxCharacters: "Maximum 2000 characters allowed.",
    },
    stepStatus: {
      dirty: "Unsaved changes",
      error: "Needs attention",
    },
    identification: {
      prefillHint: "Available details are automatically pre-filled from your Packaging record and Digital Label.",
      generateNumber: "Generate a new declaration number",
      numberHelper: "Suggested from your packaging SKU. You can change it.",
    },
    issuance: {
      placeholder: "E.g. additional voluntary information, specific conditions, or other relevant details.",
    },
    notifiedBody: {
      question: "Was a notified body involved?",
      notApplicableBody: "No notified body was involved in the conformity assessment for this packaging. Point 7 in the declaration will be shown as “Not applicable”.",
      namePlaceholder: "E.g. TÜV Rheinland LGA Products GmbH",
      addressPlaceholder: "Street, number, postal code, city, country",
      identificationNumber: "Identification number",
      certificateNumber: "Certificate reference / number",
      intervention: "Description of intervention",
      interventionPlaceholder: "E.g. Type examination (Module B) of the packaging.",
      validity: "Validity details",
      validityPlaceholder: "E.g. Valid until 14 Oct 2030.",
      certificateDate: "Certificate date",
    },
    parties: {
      type: "Type",
      importerInfo: "You do not need to list a separate importer if the company importing goods into the EU is legally considered the Manufacturer under PPWR.",
      noDetails: "No details entered yet.",
      removeImporter: "Remove importer?",
      removeRepresentative: "Remove authorised representative?",
      removeParty: "Remove party?",
      manufacturerTitle: "Manufacturer / Brand owner",
      otherParties: "Other parties",
      emptyTitle: "No other parties added yet",
      emptyHint: "Add an importer or authorised representative if applicable.",
      chooseTypeTitle: "Choose party type",
      chooseTypeDescription: "Select the party you want to add to this declaration.",
      completeManufacturer: "Complete the manufacturer details: {{fields}}.",
    },
    review: {
      generatingPdf: "Generating PDF…",
      reviewUnsaved: "Review unsaved changes",
      sign: "Sign",
      regeneratePdf: "Regenerate PDF",
      retryPdf: "Retry PDF generation",
      generatePdf: "Generate PDF",
      downloadDraftPdf: "Download draft PDF",
      issuedNotice: "This declaration is signed and issued. Saving changes to earlier steps with Next resets it to draft and removes the signature and PDF.",
      staleNotice: "This PDF was generated before your latest saved changes. Regenerate it before signing.",
      generatingDeclarationPdf: "Generating declaration PDF…",
      pdfNotAvailable: "The declaration PDF is not available yet. Fix the issue above, then use Retry PDF generation.",
      noPdf: "No PDF has been generated for this declaration yet.",
      goTo: "Go to {{step}}",
      invitationSent: "Invitation sent to {{name}} ({{email}}). Status: {{status}}. Sent {{sentAt}}; the link expires {{expiresAt}}. Sending again invalidates this link.",
      unsavedIssued: "You have unsaved changes that are not in this document. Save them with Next on the changed step.",
      unsavedDraft: "You have unsaved changes that are not in this document. Save them with Next on the changed step, then generate a new PDF before signing.",
    },
    standards: {
      title: "Standard references",
      addReference: "Add reference",
      testNo: "Test no.",
      result: "Result",
      date: "Date",
    },
    page: {
      helmet: "Create declaration of conformity",
      title: "Declaration of conformity",
      noContextSubtitle: "Open this wizard from the packaging edit form to load package context.",
      backLabel: "Document of conformity",
      noContextMessage: "No packaging product was passed in navigation state. Open Conformity from a saved package or use browser back.",
      subtitle: "Create and save a PPWR declaration of conformity for this package.",
    },
    public: {
      pageTitle: "EU Declaration of Conformity",
      status: {
        signed: "Signed",
        expired: "Expired",
        cancelled: "Cancelled",
        pending: "Pending signature",
      },
      invalidLink: "Signing link is not valid",
      inProgress: "Request already in progress.",
      notConfirmed: "The server did not confirm the signature.",
      linkExpired: "This signing link has expired.",
      linkCancelled: "This signing link was cancelled.",
      alreadySigned: "This declaration has already been signed.",
      linkUnavailable: "This signing link is no longer available.",
      secureLink: "Secure signing link",
      signingActions: "Signing actions",
      readyTitle: "Ready to sign?",
      readyText: "Please review the document and then continue to add your signature.",
      continueToSign: "Continue to sign",
      documentDetails: "Document details",
      secureNote: "You are viewing a secure signing link. This link is unique to you. Please review the document and add your signature to complete the process.",
      loading: "Loading",
      requestedBy: "Requested by {{name}}",
      signedSuccess: "Declaration {{number}} is signed.",
      number: "No. {{number}}",
      expires: "Expires {{date}}",
      closeSigningForm: "Close signing form",
    },
  },
};
